<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Approval Configuration Instance Detail">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approver Type" id="input-" size="sm" :model.sync="model.approverTypeId"   :selected="model.approverType != null ? model.approverType.name : ''" @input="getApproverTypes" />
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="input-" size="sm" :model.sync="model.approvalStructureId"   :selected="model.approvalStructure != null ? model.approvalStructure.name : ''" @input="getApprovalStructures" />
				<app-input-textbox id="fieldset-approver-level" label-cols-sm="4" label-cols-lg="3" label="Approver Level" label-for="input-approver-level" size="sm" :model.sync="model.approverLevel"  />
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Approver User Name" id="input-" size="sm" :model.sync="model.approverUserNameId"   :selected="model.approverUserName != null ? model.approverUserName.firstName : ''" @input="getUserInfos" />
				<app-input-textbox id="fieldset-stored-procedure-name" label-cols-sm="4" label-cols-lg="3" label="Stored Procedure Name" label-for="input-stored-procedure-name" size="sm" :model.sync="model.storedProcedureName"  />
				<app-input-textbox id="fieldset-approval-type" label-cols-sm="4" label-cols-lg="3" label="Approval Type" label-for="input-approval-type" size="sm" :model.sync="model.approvalType"  />
				<app-input-textbox id="fieldset-configuration-content" label-cols-sm="4" label-cols-lg="3" label="Configuration Content" label-for="input-configuration-content" size="sm" :model.sync="model.configurationContent"  />
				<b-form-group id="fieldset-is-send-notification" label-cols-sm="4" label-cols-lg="3" label="Is Send Notification" label-for="input-is-send-notification">
						<b-form-checkbox id="input-is-send-notification" v-model="model.isSendNotification"></b-form-checkbox>
					</b-form-group>
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}
</style> 
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';

import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {AppInputComboboxAutocomplete,AppInputTextbox,PopupRouterView,},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			approverTypes : [],
			approvalStructures : [],
			userInfos : [],
			isBusy: false,
		}
	},
	methods : {
		getApprovalConfigurationInstanceDetail : async function(id) {
			this.isBusy = true;
			ApprovalConfigurationInstanceDetail.getData(this, id).then(result => { this.model = result; this.isBusy = false }).catch(error => { this.isBusy = false; });
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.$emit("addButtonMethod", modalEvent, this.model); 
			}
		},
		resetModal() {
			this.$emit('resetMethod');
		},
	},
	beforeMount() {
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getUserInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getApprovalConfigurationInstanceDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getApproverTypes();
				this.getApprovalStructures();
				this.getUserInfos();
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
